import { render, staticRenderFns } from "./AboutMiniTcdc.vue?vue&type=template&id=4d064439&scoped=true"
import script from "./AboutMiniTcdc.vue?vue&type=script&lang=js"
export * from "./AboutMiniTcdc.vue?vue&type=script&lang=js"
import style0 from "./AboutMiniTcdc.vue?vue&type=style&index=0&id=4d064439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d064439",
  null
  
)

export default component.exports